import styled from "styled-components";

import OutlinedButton from "../../../../shared/components/buttons/OutlinedButton.styled";
import PrimaryButton from "../../../../shared/components/buttons/PrimaryButton.styled";
import StyledCardError from "../components/card-error/styles/StyledCardError.styled";

const CardFooter = styled.div`
  ${StyledCardError} {
    margin-bottom: 16px;
  }

  ${PrimaryButton}, ${OutlinedButton} {
    width: 100%;
  }
`;

export default CardFooter;
